<template>
	<div v-title title="发票" class="fp-page">
		<div class="top-box">
			<div class="text-box">
				<div class="title">使用积分及优惠, 手续费部分不可开具发票</div>
				<div class="text">发票由商家提供,订单确认收货后10个工作日内开票,如紧急请联系商家客服协助</div>
			</div>
		</div>
		<div class="box">
			<div class="line-key-val">
				<span class="line-key">订单编号</span>
				<div class="flex1"></div>
				<span class="line-val red"> {{ detail.orderSn }}</span>
			</div>
			<div class="line-key-val">
				<span class="line-key">开票状态</span>
				<div class="flex1"></div>
				<span class="line-val grey" v-if="detail.billMemberStatus === 0">
					待商家处理中<br>
					订单收货确认10个工作日内开票,如紧急请联系客服商家协助
				</span>
				<span class="line-val grey" v-if="detail.billMemberStatus === 1">
					已开票<br>
					请留意快递或邮箱信息，如有问题请联系客服
				</span>
			</div>
		</div>
		<div class="box">
			<div class="line-key-val">
				<span class="line-key">开票金额</span>
				<div class="flex1"></div>
				<span class="line-val red" v-if="detail.billMemberStatus === 0">具体以最终实付金额为准</span>
				<span class="line-val red" v-else>¥{{ detail.channelPayAmt }}</span>
			</div>
			<div class="line-key-val">
				<span class="line-key">发票类型</span>
				<div class="flex1"></div>
				<span class="line-val">电子普通发票</span>
			</div>
			<div class="line-key-val">
				<span class="line-key">发票抬头</span>
				<div class="flex1"></div>
				<span class="line-val">{{ detail.billPayerType === 1 ? '个人' : '企业' }}</span>
			</div>
		</div>
		<div class="box">
			<div class="line-key-val">
				<span class="line-key">抬头名称</span>
				<div class="flex1"></div>
				<span class="line-val">{{ detail.billPayerName }}</span>
			</div>
			<div class="line-key-val" v-if="detail.billPayerType === 1">
				<span class="line-key">手机号码</span>
				<div class="flex1"></div>
				<span class="line-val">{{ detail.billReceiverPhone }}</span>
			</div>
			<div class="line-key-val" v-if="detail.billPayerType === 2">
				<span class="line-key">税号</span>
				<div class="flex1"></div>
				<span class="line-val">{{ detail.billPayerRegisterNo }}</span>
			</div>
			<div class="line-key-val">
				<span class="line-key">邮箱地址</span>
				<div class="flex1"></div>
				<span class="line-val">{{ detail.billPayerType === 1 ? detail.billReceiverEmail : detail.billPayerEmail }}</span>
			</div>
		</div>
		<div class="btn-box" v-if="detail.billMemberStatus === 0">
			<div class="btn grey" @click="cancelApply">
				撤销申请
			</div>
			<div class="btn green" @click="updateApply">
				修改申请
			</div>
		</div>
		<MyDialog :dialogForm="dialogForm" />
		<div ref="maidian" td-event="2668024000,https://cloudmall.counton.com.cn/commbank-ip/#/orderFapiao"></div>
	</div>
</template>

<script>
import MyDialog from '@/components/MyDialog.vue'
export default {
	name: "Order",
	components: {
		MyDialog,
	},
	data() {
		return {
			dialogForm: {
				show: false,
				title: '',
				contentText: '',
				contentTips: '',
				// btnCancelText: '取 消',
				btnConfirmText: '',
				cancelCallback: () => {
					this.dialogForm.show = false
				},
				confirmCallback: () => {
					this.dialogForm.show = false
				}
			},
			searchForm: {
				orderId: ''
			},
			detail: {}
		};
	},
	created() {
		this.searchForm.orderId = this.$route.query.orderId
		this.getDetail()

		let self = this
		this.$nextTick(() => {
			self.$refs['maidian'].click()
		})
	},
	methods: {
		submit() {

		},
		onClickLeft() {
			this.$router.push({
				path: '/orderDetail',
				query: {
					orderId: this.$route.query.orderId,
					status: this.$route.query.status
				}
			})
		},
		getDetail() {
			this.$get('order/detail/' + this.searchForm.orderId, {}).then((res) => {
				console.log(res)
				if (res.code === this.GLOBAL.SUCCESS) {
					this.detail = res.data
				} else {
					this.$dialog.alert({
						theme: 'round-button',
						message: res.message,
						confirmButtonColor: '#00754A'
					})
				}
			})
		},
		updateApply() {
			this.$router.push({
				path: '/orderFapiaoList',
				query: {
					orderId: this.$route.query.orderId,
					status: this.$route.query.status,
					actType: 'edit'
				}
			})
		},
		cancelApply() {
			let self = this
			self.dialogForm = {
				show: true,
				title: '提示',
				contentText: '是否撤销发票申请？',
				contentTips: '',
				btnCancelText: '暂不撤销',
				btnConfirmText: '确认',
				cancelCallback: () => {
					this.dialogForm.show = false
				},
				confirmCallback: () => {
					this.dialogForm.show = false
					this.$get('order/openInvApplyCancel/' + this.$route.query.orderId, {}).then((res) => {
						console.log(res)
						if (res.code === this.GLOBAL.SUCCESS) {
							self.$toast(res.message);
							self.onClickLeft()
						} else {
							this.$dialog.alert({
								theme: 'round-button',
								message: res.message,
								confirmButtonColor: '#00754A'
							})
						}
					})
				}
			}
		}
	},
}
</script>
<style scoped lang="less">
.fp-page {
	background: #F7F7F7;
	height: 100vh;

	.top-box {
		box-sizing: border-box;
		width: 375px;
		background: #FFFFFF;
		padding: 6px 10px 10px;
		border-radius: 0px 0px 10px 10px;

		.text-box {
			box-sizing: border-box;
			width: 355px;
			background: rgba(0, 117, 74, 0.06);
			border-radius: 6px;
			padding: 8px 12px;

			.title {
				font-family: PingFangSC, PingFang SC;
				font-weight: 500;
				font-size: 11px;
				color: #00754A;
				line-height: 14px;
				text-align: left;
			}

			.text {
				margin-top: 4px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 400;
				font-size: 9px;
				color: #333333;
				line-height: 10px;
			}
		}
	}

	.box {
		box-sizing: border-box;
		margin: 10px auto;
		width: 355px;
		background: #FFFFFF;
		border-radius: 10px;
		padding: 12px;
		position: relative;


		.line-key-val {
			padding: 8px 0;
			display: flex;
			flex-direction: row;
			flex-wrap: nowrap;
			align-content: center;
			justify-content: center;
			align-items: flex-start;
			min-height: 16px;

			.flex1 {
				flex: 1;
			}

			.line-key {
				height: 16px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 400;
				font-size: 13px;
				color: #666666;
				line-height: 16px;
			}


			.line-val {
				max-width: 200px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 400;
				font-size: 13px;
				color: #333333;
				line-height: 16px;
				text-align: right;
			}

			.grey {
				color: #999999;
			}

			.red {
				color: #FF4E4E;
			}

		}

		.btn-green {
			margin: 12px 0 0 262px;
			width: 68px;
			height: 30px;
			background: #00754A;
			border-radius: 8px;
			font-family: PingFangSC, PingFang SC;
			font-weight: 500;
			font-size: 12px;
			color: #FFFFFF;
			line-height: 30px;
			text-align: center;
		}
	}

	.btn-box {
		position: fixed;
		left: 0;
		bottom: 0;
		width: 375px;
		height: 49px;
		background: #FFFFFF;
		padding: 5px 0 0;
		display: flex;
		flex-direction: row;
		flex-wrap: nowrap;
		align-content: center;
		justify-content: space-evenly;
		align-items: center;

		.btn {
			box-sizing: border-box;
			width: 172px;
			height: 40px;
			border-radius: 10px;
			font-family: PingFangSC, PingFang SC;
			font-weight: 500;
			font-size: 15px;
			color: #FFFFFF;
			line-height: 40px;
			text-align: center;
		}

		.grey {
			color: #333333;
			border: 1px solid #CCCCCC;
		}

		.green {
			background: #00754A;
			color: #FFFFFF;
		}
	}
}
</style>


// WEBPACK FOOTER //
// src/view/order/orderFapiao.vue